/* app constants */

export const TX_STATUS_NEW = 'new'
export const TX_STATUS_COMPLETED = 'completed'
export const TX_STATUS_FAILED = 'failed'
export const TX_STATUS_HOLD = 'hold'
export const TX_STATUS_PROCESSING = 'processing'
export const TX_STATUS_POST_PROCESSING = 'post_processing'
export const TX_STATUS_CUSTOMER_REVIEW = 'customer_review'
export const TX_STATUS_RESTARTED = 'restarted'
export const REACT_ENV_PRODUCTION = 'production'
export const REACT_ENV_DEVELOPMENT = 'development'
export const DOCUMENT_TYPE_PDF = 'pdf'
export const DOCUMENT_TYPE_IMAGE = 'image'
export const DOCUMENT_TYPE_OTHER = 'other'
export const TX_PHASE_KYC = 'kyc'
export const TX_PHASE_IDENTITY = 'identity'

export const BUSINESS_STATUS_ACCEPTED = 'accepted'
export const BUSINESS_STATUS_HOLD = 'hold'
export const BUSINESS_STATUS_OPEN = 'open'
export const BUSINESS_STATUS_REJECTED = 'rejected'

export const DOCUMENT_CATEGORY_FRONT = 'front'
export const DOCUMENT_CATEGORY_BACK = 'back'
export const DOCUMENT_CATEGORY_SELFIE = 'selfie'
export const DOCUMENT_CATEGORY_PASSPORT = 'passport'
export const DOCUMENT_CATEGORY_DUI_IMAGE = 'dui_image'
export const DOCUMENT_CATEGORY_RESIDENT = 'resident'
export const DOCUMENT_CATEGORIES = [
  DOCUMENT_CATEGORY_FRONT,
  DOCUMENT_CATEGORY_BACK,
  DOCUMENT_CATEGORY_SELFIE,
  DOCUMENT_CATEGORY_PASSPORT,
  DOCUMENT_CATEGORY_DUI_IMAGE,
  DOCUMENT_CATEGORY_RESIDENT,
]
export const FORM_VALIDATION_SUCCESS = 'success'
export const FORM_VALIDATION_ERROR = 'error'

export const ACCREDITATION_STATUS_OPEN = 'open'
export const ACCREDITATION_STATUS_HOLD = 'hold'
export const ACCREDITATION_STATUS_EXPIRED = 'expired'
export const ACCREDITATION_STATUS_REJECTED = 'rejected'
export const ACCREDITATION_STATUS_ACCEPTED = 'accepted'

export const E_SIGN_STATUS_AWAITING_SIGNATURE = 'awaiting_signature'
export const E_SIGN_STATUS_SIGNED = 'signed'
export const E_SIGN_STATUS_COMPLETED_KYC = 'completed_kyc'
export const E_SIGN_STATUS_SIGNED_KYC_COMPLETE = 'signed_kyc_complete'
export const E_SIGN_STATUS_ABORTED = 'aborted'
export const E_SIGN_STATUS_EXPIRED = 'expired'

export const EXPORT_VIEW_CURRENT = 'current'
export const EXPORT_VIEW_COMPLETE = 'complete'

export const API_ENDPOINT_USER_TX = '/api/transactions'
// Opt-in slim list payload. Absent => the full legacy serializer, for external clients.
export const API_VIEW_GRID = 'grid'
export const API_ENDPOINT_USER_TX_INSIGHTS = '/api/transactions/search'
export const API_ENDPOINT_USER_TX_INSIGHTS_FAST = '/api/transaction-headers'
export const API_ENDPOINT_BUSINESS_TX = '/api/business/businesses'
export const API_ENDPOINT_ACCREDITED_INVESTOR_STATUSES = '/api/accredited-investor-statuses'
export const API_ENDPOINT_APP_CONTEXT = '/api/account/app-context'
export const API_ENDPOINT_TX_APP_CONTEXT = '/api/business/app-context'
export const API_ENDPOINT_GET_AGENT_BATCH = '/api/transactions/get-agent-batch'
export const API_ENDPOINT_PUT_AGENT_BATCH = '/api/transactions/submit-agent-batch'
export const DATE_FORMAT = 'M/D/YYYY h:m:ss A'
export const DATE_FORMAT_METRICS = 'YYYY-MM-DD'

export const PAGINATION_RECORDS_PER_PAGE = 10
export const PAGINATION_MAX_BUTTONS = 10

export const STORAGE_TYPE_SESSION = 'session'
export const STORAGE_TYPE_LOCAL = 'local'
export const FEATURE_FLAG_FILE = 'ff.json'

export const SORT_ORDER_ASC = 'asc'
export const SORT_ORDER_DESC = 'desc'

export const APP_LAST_VISITED_USER_TX_URL = 'last_visited_user_tx_url'
export const ACTION_LOCATION_CHANGE = '@@router/LOCATION_CHANGE'
export const REGEX_PATTERN_UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/
export const USER_TX_DETAILS_PARENT_URI = '/tx-details/'

export const SESSION_APP_CONTEXT = 'app_context'
export const APP_USER = 'app_user'

export const METRICS_SLIDER_VALUE_TODAY = 0
export const METRICS_SLIDER_VALUE_7_DAYS = 33
export const METRICS_SLIDER_VALUE_30_DAYS = 66
export const METRICS_SLIDER_VALUE_90_DAYS_TIME = 99

export const PAGE_TITLE_HOME = 'home'

// eslint-disable-next-line no-underscore-dangle
export const __isEnvProd = () => process.env.NODE_ENV === REACT_ENV_PRODUCTION

// eslint-disable-next-line no-underscore-dangle
export const __isEnvDev = () => process.env.NODE_ENV === REACT_ENV_DEVELOPMENT

export const NAVIGATION_ID_HOME = 'home'
export const NAVIGATION_ID_USER_TRANSACTIONS = 'user-tx'
export const NAVIGATION_SELFIE_CHECK = 'selfie-check'
export const NAVIGATION_ID_BUSINESS_TRANSACTIONS = 'business-tx'
export const NAVIGATION_ID_ACCREDITATION_STATUSES = 'accreditation-statuses'
export const NAVIGATION_ID_E_SIGN = 'e-sign'
export const NAVIGATION_ID_INSIGHTS = 'insights'
export const NAVIGATION_ID_PROFILE = 'profile'
export const NAVIGATION_ID_BUSINESS_SETTINGS = 'business-settings'
export const NAVIGATION_ID_USERS = 'users'
export const NAVIGATION_ID_NOTIFICATIONS = 'notifications'
export const NAVIGATION_ID_DOCUMENTATION = 'documentation'
export const NAVIGATION_ID_SUPPORTED_DOCUMENTS = 'documentation'
export const NAVIGATION_ID_MANUAL_AML = 'manual-aml'
export const NAVIGATION_ID_ACCESS_CODES = 'access-codes'

// navigation
export const navigationItems = [
  // { id: NAVIGATION_ID_HOME, title: 'Home', path: '/', iconClass: 'fa fa-home', isParent: false, children: null, enabled: true },
  {
    id: NAVIGATION_ID_USER_TRANSACTIONS,
    title: 'KYC/AML Transactions',
    path: '/',
    iconClass: 'fa fa-users',
    isParent: true,
    children: [
      {
        id: 'tx-details',
        title: 'Transaction Details',
        path: '/tx-details',
        iconClass: null,
        isParent: false,
        children: null,
        enabled: true,
      },
    ],
    enabled: true,
  },
  {
    id: NAVIGATION_ID_BUSINESS_TRANSACTIONS,
    title: 'Business Transactions',
    path: '/businesses',
    iconClass: 'fa fa-bar-chart-o',
    isParent: true,
    children: [
      {
        id: 'business-tx-details',
        title: 'Business Transaction Details',
        path: '/business',
        iconClass: null,
        isParent: false,
        children: null,
        enabled: true,
      },
    ],
    enabled: true,
  },
  {
    id: NAVIGATION_SELFIE_CHECK,
    title: 'Face Confirmation',
    path: '/face-confirmation',
    iconClass: 'fa fa-rocket',
    isParent: false,
    enabled: true,
  },
  {
    id: NAVIGATION_ID_ACCREDITATION_STATUSES,
    title: 'Accreditation Statuses',
    path: '/accreditation-statuses',
    iconClass: 'fa fa-address-card-o',
    isParent: false,
    children: null,
    enabled: true,
  },
  {
    id: NAVIGATION_ID_E_SIGN,
    title: 'e-Sign',
    path: '/e-sign',
    iconClass: 'fa fa-certificate',
    isParent: false,
    children: null,
    enabled: true,
  },
  {
    id: NAVIGATION_ID_PROFILE,
    title: 'My Profile',
    path: '/profile',
    iconClass: 'fa fa-user-circle',
    isParent: false,
    children: null,
    enabled: true,
  },
  {
    id: NAVIGATION_ID_DOCUMENTATION,
    title: 'Documentation',
    path: '#',
    iconClass: 'fa fa-book',
    isParent: true,
    children: [
      {
        id: NAVIGATION_ID_SUPPORTED_DOCUMENTS,
        title: 'Supported Documents',
        path: '/supported-documents',
        isParent: false,
        children: null,
        enabled: true,
        render: true,
      },
      {
        id: NAVIGATION_ID_SUPPORTED_DOCUMENTS,
        title: 'KYC Information Portal',
        path: '/documentation',
        isParent: false,
        children: null,
        enabled: true,
        render: true,
      },
    ],
    enabled: true,
  },
  {
    id: NAVIGATION_ID_BUSINESS_SETTINGS,
    title: 'Business Settings',
    path: '/business-settings',
    iconClass: 'fa fa-sliders',
    isParent: false,
    children: null,
    enabled: true,
  },
  {
    id: NAVIGATION_ID_USERS,
    title: 'Users',
    path: '/users',
    iconClass: 'fa fa-users',
    isParent: false,
    children: null,
    enabled: true,
  },
  {
    id: NAVIGATION_ID_INSIGHTS,
    title: 'Insights',
    path: '/insights',
    iconClass: 'fa fa-lightbulb-o',
    isParent: false,
    children: null,
    enabled: true,
  },
  {
    id: NAVIGATION_ID_MANUAL_AML,
    title: 'Manual AML',
    path: '/manual-aml',
    iconClass: 'fa fa-play-circle',
    isParent: false,
    children: null,
    enabled: true,
  },
  {
    id: NAVIGATION_ID_ACCESS_CODES,
    title: 'Access Codes',
    path: '/access-codes',
    iconClass: 'fa fa-play-circle',
    isParent: false,
    children: null,
    enabled: true,
  },
  {
    id: NAVIGATION_ID_NOTIFICATIONS,
    title: 'Notifications',
    path: '/notifications',
    iconClass: 'fa fa-bell',
    isParent: false,
    children: null,
    enabled: true,
  },
]

/**
 * Actions list that being tracked by Session
 * @type {String[]}
 */
export const TRACKED_ACTIONS = [
  'IDENTITY_INFO_EDIT_MODAL_OPEN',
  'IDENTITY_INFO_EDIT_MODAL_CANCEL',
  'IDENTITY_INFO_EDIT_MODAL_SAVE_CHANGES',
  'IDENTITY_INFO_EDIT_UPDATE_REQUEST',
  'BUSINESS_ID_REQUEST',
  'BUSINESS_TX_STATE_UPDATE_REQUEST',
  'BUSINESS_SETTINGS_REQUEST',
  'BUSINESS_ADDRESS_EDIT_UPDATE_REQUEST',
  'BUSINESS_ADDRESS_EDIT_CREATE_REQUEST',
  'BUSINESS_INFO_EDIT_UPDATE_REQUEST',
  'BUSINESS_INFO_EDIT_UPDATE_REQUEST',
  'BUSINESS_INFO_EDIT_MODAL_OPEN',
  'BUSINESS_INFO_EDIT_MODAL_CANCEL',
  'BUSINESS_INFO_EDIT_MODAL_SAVE_CHANGES',
  'BUSINESS_ADDRESS_EDIT_MODAL_OPEN',
  'BUSINESS_ADDRESS_EDIT_MODAL_CANCEL',
  'BUSINESS_ADDRESS_EDIT_MODAL_SAVE_CHANGES',
  'SRC_LIGHTBOX_OPEN',
  'SRC_LIGHTBOX_CLOSE',
  'START_PROCESS_TRANSACTION_REQUEST',
  'START_PROCESS_TRANSACTION_MODAL_OPEN',
  'START_PROCESS_TRANSACTION_MODAL_CANCEL',
  'E_SIGN_REQUEST',
  'TX_SEARCH_START',
  'TX_SEARCH_RESET',
  'TX_CALLBACK_REQUEST',
  'TX_CALLBACK_RESET',
  'MODAL_CONFIRMATION_OPEN',
  'MODAL_CONFIRMATION_CANCEL',
  'MODAL_CONFIRMATION_CLOSE',
  'MODAL_CONFIRMATION_VALIDATE',
  'GET_USER_REQUEST',
  'GET_SUPPORTED_DOCUMENTS_REQUEST',
  'GET_HOW_TO_DOCUMENTATION_REQUEST',
  'IDENTITY_PDF_MODAL_OPEN',
  'IDENTITY_PDF_MODAL_CLOSE',
  'UPDATE_BUSINESS_SETTINGS_REQUEST',
  'UPDATE_DOCUMENT_REQUEST',
  'UPDATE_USER_REQUEST',
  'USER_TX_REQUEST',
  'USER_TX_ID_REQUEST',
  'USER_TX_REQUEST_INSIGHTS',
  'GET_AGENT_BATCH_REQUEST',
  'PUT_AGENT_BATCH_REQUEST',
]

export const MY_VERIFY_INFO_URL = __isEnvProd() ? 'https://kyc.myverify.info' : 'https://dev-kyc.myverify.info'
